
import {Link, useNavigate} from 'react-router-dom';
import {Grid, LogOut} from 'react-feather';
import {FaUserCog} from "react-icons/fa"
import {BiCog} from 'react-icons/bi'
import {Dropdown, DropdownButton} from "react-bootstrap";
import Logged from "../modules/user/Logged";

const Topbar = () => {
    const navigate = useNavigate();

    const logOut = () => {
        window.localStorage.removeItem('_tkn');
        window.location.href = '/auth/login';
    }

    const handleClickAccount = () => {
        navigate('/myaccount')
    }


    return (
        <div className="Topbar">
            <div className="row">
                <div className="col-sm-6 v-align">
                    <ul className="list-inline list-unstyled">
                        <li className="list-inline-item">
                            <Link to="/">
                                <Grid/>
                            </Link>
                        </li>
                    </ul>
                </div>
                <div className="col-sm-6 text-end">
                    <ul className="list-inline list-unstyled">
                        <li className="list-inline-item">
                            <DropdownButton id="dropdown-basic-button" variant="white" title={<FaUserCog/>}>

                                <Dropdown.Item className="LoggedContainer">
                                    <Logged/>
                                </Dropdown.Item>

                                <Dropdown.Item onClick={handleClickAccount}>
                                    <BiCog/> Account
                                </Dropdown.Item>

                                <Dropdown.Item onClick={logOut}>
                                    <LogOut/> Logout
                                </Dropdown.Item>

                            </DropdownButton>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    );
}

export default Topbar;